import React from 'react'
import { Link } from 'react-router-dom'
import logoWhite from '../resources/speed-lab-logo-dark.svg'

const Footer = () => {
  return (
    <footer className='site-footer' id='contact'>
      <div className='container-wide'>
        <div className='site-footer__grid'>
          <div className='site-footer__about'>
            <img src={logoWhite} alt='SPEED Lab' className='site-footer__logo' />
            <p>
              Secure Prediction, Edge AI and Multimodal LLM Lab. Building
              robust, efficient, trustworthy, and controllable AI systems.
            </p>
          </div>

          <div>
            <h6>Explore</h6>
            <ul>
              <li>
                <Link to='/publications'>Publications</Link>
              </li>
              <li>
                <Link to='/news'>News</Link>
              </li>
              <li>
                <Link to='/team'>Team</Link>
              </li>
              <li>
                <Link to='/resources'>Resources</Link>
              </li>
            </ul>
          </div>

          <div>
            <h6>Visit</h6>
            <address>
              Florida Atlantic University
              <br />
              Dept. of Electrical Engineering &amp; Computer Science
              <br />
              777 Glades Road, EE 321
              <br />
              Boca Raton, FL 33431-0991
            </address>
          </div>

          <div>
            <h6>Connect</h6>
            <div className='site-footer__social'>
              <a
                href='mailto:aimteaj@fau.edu'
                aria-label='Email aimteaj@fau.edu'
                title='aimteaj@fau.edu'
              >
                <i className='fas fa-envelope'></i>
              </a>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://www.linkedin.com/in/speed-lab-a7a1422a2/'
                aria-label='LinkedIn'
              >
                <i className='fa-brands fa-linkedin-in'></i>
              </a>
              <a
                target='_blank'
                rel='noreferrer'
                href='https://github.com/speedlab-git'
                aria-label='GitHub'
              >
                <i className='fa-brands fa-github'></i>
              </a>
            </div>
          </div>
        </div>

        <div className='site-footer__bottom'>
          <span>
            © {new Date().getFullYear()} SPEED Lab
          </span>
          <span>Florida Atlantic University</span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
